<template>
    <p>
        <template v-if="dto.head">
            <span v-html="dto.head" /><br>
        </template>

        <template v-if="dto.trunk">
            <span v-html="dto.trunk" /><br>
        </template>


        <template v-if="dto.member">
            <span v-html="dto.member" /><br>
        </template>
    </p>
</template>

<script>
export default {
    name: "Das",
    props: {
        dto: {
            type: Object,
            required: true
        }
    }
}
</script>
